import { z } from "zod"

const tokenInfo = z.object({
  address: z.string(),
  symbol: z.string(),
  decimals: z.number(),
})

const statsTopPairsAprsItem = z.object({
  address: z.string(),
  apr: z.number(),
  symbol: z.string(),
  displayName: z.string(),
  displayType: z.string(),
  extendedType: z.string().nullable(),
  token0: tokenInfo,
  token1: tokenInfo,
  tvl: z.number(),
  isEquityPair: z.boolean(),
  stable: z.boolean(),
})

export const statsTopPairsAprsResponseSchema = z.array(statsTopPairsAprsItem)

export type StatsTopPairsAprsResponse = z.infer<typeof statsTopPairsAprsResponseSchema>
export type StatsTopPairsAprsResponseItem = StatsTopPairsAprsResponse[number]
